import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import ResumeContext from "./Resumecontext";
import parse from "html-react-parser";
import { resumeBuilderSelector } from "./ResumeBuilderActions/selector";
import { setCurrentSection } from "./ResumeBuilderActions/actions";
import { myCandidatesSelector } from "../MyCandidates/redux/selector";
import { userSelector } from "../user-redux/selector";

export default function AddSkills({ setValue, setAddedSkills }) {
  const dispatch = useDispatch();
  const contextObject = useContext(ResumeContext);
  const formikRef = useRef();
  const location = useLocation();
  const [inputValue, setInputValue] = useState('');
  const [unMatchedSkills, setUnMatchedSkills] = useState({});
  const { resumeFullDetails, currentSection } = useSelector(
    resumeBuilderSelector
  );

  //console.log("resumeBuilderSelector", resumeFullDetails);
  const { selectedJob, primaryResumeDetails, candidateSelectedResume } =
    useSelector(appSelector);
  const { jobDetails } = useSelector(myCandidatesSelector);
  const { user } = useSelector(userSelector);
  const { projectdetails = [] } = resumeFullDetails || {};
  const handleInputChange = (newValue) => {
    const uniqueSkills =
      newValue?.length > 0
        ? Array.from(new Set(newValue.map((skill) => skill.trim())))
        : [];
    setAddedSkills(uniqueSkills)
    formikRef.current.setFieldValue("skills", uniqueSkills);
    contextObject.updateAISkills(uniqueSkills);
  };

  useEffect(() => {
    const fetch = async () => {
      let resumeskills;
      let activeJobSkills;

      if (user?.user_type_id === 6 || user?.user_type_id === "6") {
        resumeskills = primaryResumeDetails?.ai_skills
          ? primaryResumeDetails?.ai_skills
          : candidateSelectedResume?.ai_skills;
        activeJobSkills = selectedJob?.required_skills;
      } else {
        resumeskills = primaryResumeDetails?.ai_skills
          || candidateSelectedResume?.ai_skills
          || resumeFullDetails?.resumedetails?.ai_skills;
        activeJobSkills = selectedJob?.required_skills || jobDetails?.required_skills;
      }

      console.log("resumeskills", resumeskills);
      console.log("selectedJob skills", activeJobSkills);

      if (
        typeof resumeskills === "string" &&
        typeof activeJobSkills === "string"
      ) {
        const resumeSkillsString = resumeskills;
        const jobSkillsString = activeJobSkills;
        //console.log("Matched Skillsjo", jobSkillsString);
        const resumeSkills = new Set(
          resumeSkillsString
            .split(",")
            .map((skill) => skill.toLowerCase().trim())
        );
        const jobSkills = new Set(
          jobSkillsString.split(",").map((skill) => skill.toLowerCase().trim())
        );
        const matchedSkills = new Set(
          [...jobSkills].filter((skill) => resumeSkills.has(skill))
        );
        const unmatchedSkillsFromJob = new Set(
          [...jobSkills].filter((skill) => !resumeSkills.has(skill))
        );
        //console.log("Matched Skills:", [...matchedSkills]);
        // console.log("Matched Skills from Job Skills:", [
        //   ...unmatchedSkillsFromJob,
        // ]);
        setUnMatchedSkills([...unmatchedSkillsFromJob]);
      }
    };

    if (user?.user_type_id === 6 || user?.user_type_id === "6") {
      if (selectedJob?.required_skills) {
        fetch();
      }
    } else {
      if (selectedJob?.required_skills || jobDetails?.required_skills) {
        fetch();
      }
    }
  }, [selectedJob?.required_skills, jobDetails?.required_skills, primaryResumeDetails?.ai_skills, candidateSelectedResume?.ai_skills, resumeFullDetails?.resumedetails?.ai_skills, user?.user_type_id]);

  const submit = async () => {
    // First update the current section
    await dispatch(setCurrentSection("Project", projectdetails[0]?.id));

    // Then navigate to Projects
    setValue(3);
  };
  const [open, setOpen] = useState(false);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };
  return (
    <Box
      sx={{
        padding: 2,
        border: "1px solid #e6e1e1",
        borderRadius: "10px",
        borderTop: "3px solid #406682",
        boxShadow: "0 0 2px grey",
      }}
    >
      <Grid container>
        <Grid xs={6}>
          <Typography
            variant="h6"
            sx={{
              background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              fontWeight: "bold",
            }}
          >
            Add Skills
          </Typography>
          <Typography sx={{ color: "grey", mb: 1 }}>
            Enhance Your Resume with Job-Ready Skills
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            textAlign: "right",
            alignItems: "center",
          }}
        >
          <Button
            onClick={openDialog}
            sx={{
              fontSize: "13px",
              // fontWeight: 600,
              padding: "0px 10px",
              height: "30px",
              borderRadius: "22px 22px 22px 22px",
              color: "#406682",
              textTransform: "none",
              backgroundColor: "white",
              cursor: "pointer",
              border: "1px solid #406682",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "#406682",
                color: "white",
                border: "1px solid #406682",
              },
            }}
          >
            Job Description
          </Button>
        </Grid>
      </Grid>

      <Formik
        innerRef={formikRef}
        initialValues={{
          skills: contextObject.aiSkills || "",
        }}
        validationSchema={Yup.object({
          //skills: Yup.array().min(1, "Please select at least one skill"),
        })}
        onSubmit={(values) => {
          //console.log("New Skills1", values);
          //  handleUpdateSkills(values)
          submit();
        }}
      >
        {({ values, handleBlur, handleSubmit, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            <Autocomplete
              multiple
              id="skills"
              name="skills"
              freeSolo
              options={[]}
              value={contextObject?.aiSkills ?? []}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              onChange={(event, newValue) => {
                if (Array.isArray(newValue)) {
                  handleInputChange(newValue);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && inputValue) {
                  e.preventDefault();
                  e.stopPropagation();

                  const newSkill = inputValue.trim();
                  if (newSkill && !contextObject?.aiSkills?.includes(newSkill)) {
                    handleInputChange([...contextObject?.aiSkills, newSkill]);
                    setInputValue(''); // Clear the input
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Add Skills"
                  fullWidth
                />
              )}
              renderTags={(value, getTagProps) =>
                value?.length > 0 &&
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    {...getTagProps({ index })}
                    onDelete={() => {
                      const newSkills = value.filter((_, i) => i !== index);
                      handleInputChange(newSkills);
                    }}
                    sx={{
                      height: "27px",
                      fontSize: "12px",
                      textTransform: "capitalize",
                    }}
                  />
                ))
              }
            />
            <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
              {/* {console.log(unMatchedSkills)} */}
              {unMatchedSkills?.length > 0 &&
                unMatchedSkills
                  ?.filter((skill) => !values?.skills?.includes(skill))
                  .map((skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      variant="outlined"
                      onClick={() =>
                        handleInputChange([...values?.skills, skill])
                      }
                      sx={{
                        cursor: "pointer",
                        height: "27px",
                        fontSize: "12px",
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    />
                  ))}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                size="small"
                sx={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  bgcolor: "#53778e",
                  color: "white",
                  textTransform: "capitalize",
                }}
                onClick={() => setValue(1)}
              >
                Previous
              </Button>
              <Button
                variant="contained"
                type="submit"
                size="small"
                sx={{
                  float: "right",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  bgcolor: "#53778e",
                  color: "white",
                  textTransform: "capitalize",
                }}
              // onClick={() => setValue(3)}
              >
                Next
              </Button>
            </Box>
            {/* {
                  update === true ?  <Typography>
                  You want to add updated Resume ! Click on
                   {
                  download === true ? (
                      <Button style={{ textTransform: "capitalize" }} disabled>
                        Downloading...
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          contextObject.updateFinishOne(true);
                          setDownload(true);
                        }}
                        style={{
                          textTransform: "capitalize",
                          textDecoration: "underline",
                        }}
                      >
                        Download
                      </Button>
                    )}
              </Typography> : <></>
              } */}
          </form>
        )}
      </Formik>
      <Dialog
        open={open}
        onClose={closeDialog}
        fullWidth
        sx={{ "& .MuiDialog-paper": { width: "750px", maxWidth: "90%" } }}
      >
        <DialogContent>
          <Box
            sx={{
              marginBottom: "15px",
              padding: 2,
              border: "1px solid #e6e1e1",
              borderRadius: "10px",
              borderTop: "3px solid #406682",
              boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography variant="h6">
              <span
                style={{
                  background:
                    "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold",
                }}
              >
                Job Title:
              </span>
              {` ${selectedJob?.jobtitle}`}
            </Typography>
          </Box>

          <Box
            sx={{
              padding: 2,
              //border: "1px solid #e6e1e1",
              borderRadius: "10px",
              // borderTop: "3px solid #406682",
              // boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography
              variant="h6"
              sx={{
                background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              Job Description
            </Typography>
            <Typography paragraph>
              {selectedJob?.job_description !== null &&
                selectedJob?.job_description !== undefined &&
                selectedJob?.job_description
                ? !selectedJob?.job_description.includes("ahref") &&
                  !selectedJob?.job_description.includes("divclass") &&
                  !selectedJob?.job_description.includes("aclass") &&
                  !selectedJob?.job_description.includes("pclass") &&
                  !selectedJob?.job_description.includes("liclass")
                  ? parse(selectedJob?.job_description)
                  : selectedJob?.job_description.replace(/<[^>]+>/g, "")
                : ""}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
